export default __webpack_public_path__ + "static/travelers-1c230501b072a6906322f3625a8e1801.svg";